export default "__VITE_ASSET__BkkrzrCb__"